/*global jQuery, $ */

import 'jquery';
import 'bootstrap-sass';
import 'bootstrap-daterangepicker';
import 'jquery-bar-rating';
import 'jquery-match-height';
import 'jquery-jpostal-ja';
import 'select2';
import Stickyfill from 'stickyfilljs';
import './config';
import '../lib/globalNav';
import '../lib/backToTopLink';
import '../lib/loginForm';
import {Notification} from "../lib/notification";

import moment from 'moment-timezone';

moment.locale('ja');

function initializeOverlay() {
  $(document).on('submit', 'form[data-overlay]', function () {
    const indicator = $('<div class="loading"><i class="fa fa-refresh fa-spin"></i></div>')
      .appendTo($('body'));

    window.addEventListener('pagehide', () => {
      indicator.remove();
    });
  });
}

function initializeAjax() {
  $.ajaxSetup({
    headers: {
      'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
    },
  });
}

function initializeDateRangePickerDefaultOption() {
  $.fn.daterangepicker.defaultOptions = $.extend(true, {}, $.fn.daterangepicker.defaultOptions, {
    locale: {
      format: 'YYYY-MM-DD',
      'daysOfWeek': [
        '日',
        '月',
        '火',
        '水',
        '木',
        '金',
        '土',
      ],
      'monthNames': [
        '1月',
        '2月',
        '3月',
        '4月',
        '5月',
        '6月',
        '7月',
        '8月',
        '9月',
        '10月',
        '11月',
        '12月',
      ],
    },
  });
}

function initializeDatePicker() {
  $('input[data-datepicker]').each(function () {
    let options = {
      singleDatePicker: true,
      timePicker: false,
      timePicker24Hour: true,
      autoUpdateInput: false,
      locale: {
        format: 'YYYY-MM-DD',
        'daysOfWeek': [
          '日',
          '月',
          '火',
          '水',
          '木',
          '金',
          '土',
        ],
        'monthNames': [
          '1月',
          '2月',
          '3月',
          '4月',
          '5月',
          '6月',
          '7月',
          '8月',
          '9月',
          '10月',
          '11月',
          '12月',
        ],
      },
    };

    let inlineOptions = this.getAttribute('data-datepicker');

    if (typeof inlineOptions === 'string') {
      options = $.extend(true, options, inlineOptions);
    }

    $(this)
      .daterangepicker(options)
      .on('apply.daterangepicker', function (e, picker) {
        picker.element.val(picker.startDate.format(picker.locale.format));
      });
  });
}

function initializeDateTimePicker() {
  $('input[data-datetimepicker]').each(function () {
    let options = {
      singleDatePicker: true,
      timePicker: true,
      timePicker24Hour: true,
      autoUpdateInput: false,
      locale: {
        format: 'YYYY-MM-DD HH:mm:ss',
      },
    };

    let inlineOptions = this.getAttribute('data-datetimepicker');

    if (typeof inlineOptions === 'string') {
      options = $.extend(true, options, inlineOptions);
    }

    $(this)
      .daterangepicker(options)
      .on('apply.daterangepicker', function (e, picker) {
        picker.element.val(picker.startDate.format(picker.locale.format));
      });
  });
}

$(function () {
  initializeOverlay();
  initializeAjax();
  // initializeDateRangePicker();
  initializeDatePicker();
  initializeDateTimePicker();
});

$(function () {
  $('.shop_image article').css('height', $('.shop_image article').width());
});

$(function () {
  let b = $('section.single_shop_main .main .main_photoflex .photolist .imgbox');
  let aticleH = b.width();
  $('section.single_shop_main .main .main_photoflex .photolist .imgbox').css('height', aticleH);
});

$(function () {
  $(window).on('resize', function () {
    let b = $('.shop_image article');
    let aticleH = b.width();
    $('.shop_image article').css('height', aticleH);
  });

  $(window).on('resize', function () {
    let b = $('section.single_shop_main .main .main_photoflex .photolist .imgbox');
    let aticleH = b.width();
    $('section.single_shop_main .main .main_photoflex .photolist .imgbox').css('height', aticleH);
  });

  $('.aside_menu_btn').on('click', function () {
    $(this).next().slideToggle();
  });

  $('.area_menu ul li').on('click', function () {
    $(this).children('.child').slideToggle();

  });

  $('.fulltext').on('click', function () {
    $(this).next().slideToggle();
    $(this).slideToggle();
  });
});

$(function () {
  initializeDateRangePickerDefaultOption();
});

$(function () {
  $('#sp_menu').on('click', function () {
    let $header = $('header');
    let $menuIcon = $('#sp_menu > i');
    let $menuShow = $('header nav');
    let $noneHover = $('header nav li .child');
    let $noneHoverArea = $('header nav li .child').not('header nav li .area_menu');
    $header.toggleClass('menu_show');
    $menuIcon.toggleClass('fa-bars fa-times');
    $noneHover.toggleClass('child');
    $noneHoverArea.toggleClass('sp_menushow');
    $menuShow.slideToggle().toggleClass('menu-show');
  });
});

$(function () {
  var startPos = 0, winScrollTop = 0;
  // scrollイベントを設定
  document.querySelector('html body').addEventListener('scroll', function () {
    //winScrollTop = window.pageYOffset;
    winScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    if (winScrollTop >= startPos) {
      // 下にスクロールされた時
      if (winScrollTop >= 800) {
        // 下に800pxスクロールされたら隠す
        document.querySelector('.notification-box').classList.remove('notification-show');
        document.querySelector('.notification-box').classList.add('notification-hide');
      }
    } else {
      // 上にスクロールされた時
      document.querySelector('.notification-box').classList.remove('notification-hide');
      document.querySelector('.notification-box').classList.add('notification-show');
    }
    startPos = winScrollTop;
  });
});

let quickSearchBar = document.querySelectorAll('#quick-search-bar');

if (quickSearchBar) {
  Stickyfill.add(quickSearchBar);
}

document.addEventListener('DOMContentLoaded', () => {
  const notification = new Notification();
  notification.initialize();
});

document.addEventListener("DOMContentLoaded", () => {
  const customerTermContent = document.querySelector("#customer-term-content");

  if(!customerTermContent){
    return;
  }

    // 無効化するキー一覧
    const blockedKeys = [
      { ctrlKey: true, shiftKey: true, key: 'J' },//for Windows
      { ctrlKey: true, shiftKey: true, key: 'I' },
      { ctrlKey: true, shiftKey: true, key: 'Z' },
      { ctrlKey: true, shiftKey: true, key: 'K' },
      { ctrlKey: true, shiftKey: true, key: 'E' },
      { ctrlKey: true, shiftKey: true, key: 'C' },
      { ctrlKey: true, shiftKey: true, key: 'P' },
      { ctrlKey: true, key: 'c' },
      { ctrlKey: true, key: 'x' },
      { ctrlKey: true, key: 'v' },
      { ctrlKey: true, key: 'a' },
      { ctrlKey: true, key: 's' },
      { ctrlKey: true, key: 'p' },
      { ctrlKey: true, key: 'u' },
      { ctrlKey: true, key: 'f' },
      { ctrlKey: true, key: 'h' },
      { ctrlKey: true, key: 'r' },
      { metaKey: true, altKey: true, key: 'J' },//for Mac
      { metaKey: true, altKey: true, key: 'I' },
      { metaKey: true, altKey: true, key: 'Z' },
      { metaKey: true, altKey: true, key: 'K' },
      { metaKey: true, altKey: true, key: 'E' },
      { metaKey: true, altKey: true, key: 'C' },
      { metaKey: true, altKey: true, key: 'U' },
      { metaKey: true, key: 'c' },
      { metaKey: true, key: 'x' },
      { metaKey: true, key: 'v' },
      { metaKey: true, key: 'a' },
      { metaKey: true, key: 's' },
      { metaKey: true, key: 'p' },
      { metaKey: true, key: 'u' },
      { metaKey: true, key: 'f' },
      { metaKey: true, key: 'h' },
      { metaKey: true, key: 'r' },
      { shiftKey: true, key: 'F5' },//common
      { shiftKey: true, key: 'F7' },
      { shiftKey: true, key: 'F9' },
      { key: 'F12' }
    ];

  customerTermContent.addEventListener("copy", (e) => {
    e.preventDefault();
  });

  customerTermContent.addEventListener("contextmenu", (e) => {
    e.preventDefault();
  });

  window.addEventListener('keydown', function(e) {
    const isBlocked = blockedKeys.some(function(condition) {
        return (condition.ctrlKey === undefined || condition.ctrlKey === e.ctrlKey) &&
            (condition.shiftKey === undefined || condition.shiftKey === e.shiftKey) &&
            (condition.altKey === undefined || condition.altKey === e.altKey) &&
            (condition.metaKey === undefined || condition.metaKey === e.metaKey) &&
            condition.key === e.key;
    });
    if (isBlocked) {
        e.preventDefault();
    }
  });
});


//ストアURLを定義
function getAppURL(data) {
  const googleUrl = 'https://play.google.com/store/apps/details?id=jp.ajg.heyagoto';
  const appleUrl = 'https://apps.apple.com/jp/app/id1579265807';
  
  const returnURL = data ? googleUrl : appleUrl;//true:googleUrl false:appleUrl
  return returnURL;
}

/*  Seilooアプリのリンク先をAppStoreかGooglePlayにする
*   javascript:seilooAppLink();void(0)
*/ 
window.seilooAppLink = function () {
  const ua = navigator.userAgent.toLowerCase();
  const matchua = ua.match(/iphone|ipad|android|macintosh/);
  let targetURL;
  //スマホかPCで分岐
  if (matchua) {
    const mobileos = matchua[0].toLowerCase();
    const mobileUrl = getAppURL(mobileos === 'android');
    targetURL = mobileUrl;
  } else {
    const os = navigator.userAgentData.platform.toLowerCase();
    const matchos = os.match(/macintosh|macintel|macppc|mac68k/);
    const pceUrl = getAppURL(matchos == null ? true : false);//apple以外をtrueに変換
    targetURL = pceUrl;
  }
  window.open(targetURL, '_blank');
}
